export default "__VITE_ASSET__B5Q7bVoJ__"